﻿import { Component, OnInit } from '@angular/core';

import { RestService } from 'src/app/_services/rest.service';
import { Router } from '@angular/router';

@Component({ templateUrl: 'params.component.html' })
export class ParamsComponent implements OnInit {

    params: any;

    constructor(private restService: RestService, private router: Router) {
        this.loadAll();
    }

    ngOnInit() {
    }



    edit(paramId: string) {
        this.router.navigate(['/root/params/' + paramId]);
    }

    private loadAll() {
        this.restService.getAll('/rest-api/root/param').subscribe(data => {
            this.params = data;
        });
    }
}
